import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { CookieProperty } from "./cookieProperty.js";
import { joinWithAndSeparator } from "../../../hooks/common/useTeachings.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
import { LinkToggle } from "../linkToggle.js";
const CookiePropertyListLessRelevant = ({ expandable, children, labelModifications = {}, groupLabel })=>{
    const { group: { detailsHideLessRelevant }, i18n: { andSeparator, showLessRelevantDetails, hideLessRelevantDetails } } = useBannerOrBlocker();
    const ref = useRef(null);
    const [joinedAnd, setJoinedAnd] = useState("");
    useEffect(()=>{
        const { current } = ref;
        if (current) {
            const labels = [
                ...new Set([
                    ...current.querySelectorAll(":scope>div>strong")
                ].map((c)=>{
                    const originalLabel = c.innerText.replace(/:?\s+$/, "");
                    return labelModifications[originalLabel] || originalLabel;
                }))
            ];
            setJoinedAnd(joinWithAndSeparator(labels, andSeparator));
        }
    }, [
        ref.current,
        labelModifications
    ]);
    const replaceVariables = useCallback((str)=>str.replace("%s", joinedAnd), [
        joinedAnd
    ]);
    return detailsHideLessRelevant && expandable ? /*#__PURE__*/ _jsx("div", {
        "aria-hidden": !joinedAnd,
        hidden: !joinedAnd,
        children: /*#__PURE__*/ _jsx(CookieProperty, {
            value: /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx(LinkToggle, {
                        showMore: replaceVariables(showLessRelevantDetails),
                        hideMore: replaceVariables(hideLessRelevantDetails),
                        style: {
                            fontStyle: "italic"
                        },
                        forceRender: true,
                        groupLabel: groupLabel,
                        children: /*#__PURE__*/ _jsxs("div", {
                            ref: ref,
                            children: [
                                /*#__PURE__*/ _jsx("br", {}),
                                children
                            ]
                        })
                    })
                ]
            })
        })
    }) : children;
};
export { CookiePropertyListLessRelevant };
